import classnames from 'classnames'
import React from 'react'
import { Link, Route } from 'react-router-dom'

import { iconEvidenceShadowed } from 'modules/ui/assets'
import { Image, Button } from 'modules/ui'
import DraggableIconLayer from './DraggableIconLayer'
import Help from './Help'
import Parts from './Parts'

import enhance from './enhancers'

export function Builder(props) {
  const {
    argument,
    completed,
    containerWidth,
    handleImageLoad,
    handleMeasure,
    imageLoaded,
    theme
  } = props

  const className = classnames(theme.builder, {
    [theme.imageLoaded]: imageLoaded
  })

  return (
    <div className={className}>
      <Route component={Help} path='/argument/:id/builder/help' />

      <div className={theme.argumentInfo} style={{ width: containerWidth }}>
        <h1 className={theme.argumentText}>
          {argument.text}
        </h1>

        <Link
            replace
            className={theme.help}
            to={`/argument/${argument.id}/builder/help`}>
          Support Your Claim
          <span className={theme.helpIcon} />
        </Link>
      </div>

      <Image
          handleImageLoad={handleImageLoad}
          src={argument.imgUrl}
          theme={theme}
          onMeasure={handleMeasure}>
        <Parts ready={imageLoaded} />
        <DraggableIconLayer iconSrc={iconEvidenceShadowed} />
      </Image>

      <div className={theme.action}>
        <Button
            primary
            raised
            disabled={!completed}
            icon='arrow_forward'
            to={`/argument/${argument.id}/strongest`} />
      </div>
    </div>
  )
}

export default enhance(Builder)



// WEBPACK FOOTER //
// ./client/modules/debate/components/Builder/index.js